import { render } from "./VZB.vue?vue&type=template&id=806b8d1e&scoped=true"
import script from "./VZB.vue?vue&type=script&lang=js"
export * from "./VZB.vue?vue&type=script&lang=js"

import "./VZB.vue?vue&type=style&index=0&id=806b8d1e&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806b8d1e"]])

export default __exports__